//  Page Header

<template>
  <div>
    <el-page-header @back="_clickHeaderBack" :content="titleStr"></el-page-header>
  </div>
</template>

<script>
export default {
  name: "AppPageHeader",
  props: {
    subtitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: null
    };
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    init() {},
    _clickHeaderBack() {
      // this.$router.replace("/");
      this.$router.back();
    },
    fetchData() {
      this.title = this.$route.name;
    }
  },
  mounted: function() {
    // console.log("el menu : " + sessionStorage["loggedRole"]);
  },
  created() {
    this.fetchData();
  },
  computed: {
    titleStr: function() {
      let str = this.$route.name + this.subtitle;
      return str;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
